<template>
    <div class="transaction-details">
        <b-card class="transparent-card">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <div class="headers-box">
                    <h3>Transaction #{{transactionData.transactionId}}</h3>
                    <h4>Request Type: <strong>{{transactionData.transactionType}}</strong></h4>
                </div>

                <div class="button-wrapper">
                    <button class="btn btn-danger btn-cancel-change-plan" v-if="transactionData.transactionType == 'Rate Plan Change' &&  showCancelButton" @click="cancelRatePlanChange()">Cancel Rate Plan Change</button>
                    <button v-if="superAdmin && transactionData.carrierId == 1 && (transactionData.transactionStatus == 'Failure' || transactionData.transactionStatus == 'Partially completed')" class="btn btn-success action-element" @click="retryTransaction()">Retry</button>
                    <button class="btn btn-primary" @click="openExportModal()">Export Log</button>
                </div>
            </b-card-header>
            <b-card-body>
                <b-row class="details-row">
                    <b-col md="4">
                        <div class="inner-box">
                            <h4 class="box-title">Details</h4>
                            <b-row>
                                <b-col md="6">
                                    <span class="label">Request Status</span>
                                    <span class="value">{{transactionData.transactionStatus}}</span>
                                </b-col>
                                <b-col md="6">
                                    <span class="label">Release Date</span>
                                    <span class="value">{{transactionData.releaseAfterUtc}}</span>
                                </b-col>
                                <b-col md="6">
                                    <span class="label">Request Created</span>
                                    <span class="value">{{transactionData.createdAt}}</span>
                                </b-col>
                                <b-col md="6">
                                    <span class="label">Request Completed</span>
                                    <span class="value">{{transactionData.completedAt}}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col md="4">
                        <div class="inner-box">
                            <h4 class="box-title">Status</h4>

                            <b-row>
                                <b-col md="6">
                                    <span class="label">Status</span>
                                    <span class="value">{{successCount}} of {{transactionData.noOfSims}} Transactions succeeded</span>
                                </b-col>
                                <b-col md="6">
                                    <span class="label">Errors</span>
                                    <span class="value">{{errorCount}}</span>
                                </b-col>
                                <b-col md="6">
                                    <span class="label">In Queue</span>
                                    <span class="value">{{queuedCount}}</span>
                                </b-col>
                                <b-col md="6">
                                    <span class="label">Number of SIMs</span>
                                    <span class="value">{{transactionData.noOfSims}}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col md="4">
                        <div class="inner-box">
                            <h4 class="box-title">Created by</h4>

                            <b-row>
                                <b-col md="6">
                                    <span class="label">First Name</span>
                                    <span class="value">{{userFirstName}}</span>
                                </b-col>
                                <b-col md="6">
                                    <span class="label">Last Name</span>
                                    <span class="value">{{userLastName}}</span>
                                </b-col>
                                <b-col md="6">
                                    <span class="label">E-mail</span>
                                    <span class="value">{{userEmail}}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="plans-vf-tags-row" v-if="displayPlanDetails && transactionData.ratePlan">
                    <b-col :md="transactionData.transactionType == 'Activation' ? 6 : 12">
                        <div class="inner-box plan-details">
                            <div class="plan-name-row">
                                <h6>Plan Name</h6>
                                <div class="plan-name-category-box">
                                    <h4 class="plan-name">{{transactionData.ratePlan.planName}}</h4>
                                    <h5 :class="['plan-category', transactionData.ratePlan.planCategory.planCategoryClass]">{{transactionData.ratePlan.planCategory.planCategoryName}}</h5>
                                </div>
                            </div>
                            <div v-if="transactionData.ratePlan.carrierId == 1" class="plan-details-columns">
                                <div class="plan-details-column">
                                    <div v-if="transactionData.ratePlan.dataLimit" class="option">
                                        <div class="name">Data Plan</div>
                                        <div class="value">{{transactionData.ratePlan.dataLimit.dataLimitName}}</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">Tier 1 International Roaming</div>
                                        <div v-if="planInter" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">Tier 2 International Roaming</div>
                                        <div v-if="planInter2" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">Alert 1</div>
                                        <div v-if="planInter" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">Alert 2</div>
                                        <div v-if="planInter" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div v-if="hotSpotVisible" class="option">
                                        <div class="name">Hot Spot</div>
                                        <div v-if="hotSpot" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                </div>
                                <div class="plan-details-column">
                                    <div class="option">
                                        <div class="name">APN</div>
                                        <div v-if="planSMS" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">Voice</div>
                                        <div v-if="voice" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">SMS</div>
                                        <div v-if="planSMS" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div class="option">
                                        <div v-if="transactionData.ratePlan.dataGuard && transactionData.ratePlan.dataGuard.hasThrottle" class="name">Throttle {{transactionData.ratePlan.dataGuard.throttleAt}} {{transactionData.ratePlan.dataGuard.throttleAtUnit}} {{transactionData.ratePlan.dataGuard.throttleSpeed.throttleSpeedName}}</div>
                                        <div v-else class="name">Throttle</div>
                                        <div v-if="transactionData.ratePlan.dataGuard && transactionData.ratePlan.dataGuard.hasThrottle" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div class="option">
                                        <div v-if="transactionData.ratePlan.dataGuard && transactionData.ratePlan.dataGuard.hasCap" class="name">Cap {{transactionData.ratePlan.dataGuard.capAt}} {{transactionData.ratePlan.dataGuard.capUnit}}</div>
                                        <div v-else class="name">Cap</div>
                                        <div v-if="transactionData.ratePlan.dataGuard && transactionData.ratePlan.dataGuard.hasCap" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">Static IP</div>
                                        <div v-if="static" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="transactionData.ratePlan.carrierId == 2" class="plan-details-columns">
                                <div class="plan-details-column">
                                    <div v-if="transactionData.ratePlan" class="option">
                                        <div class="name">Static IP</div>
                                        <div v-if="transactionData.ratePlan.staticIp" class="value on">ON</div>
                                        <div v-else class="value">OFF</div>
                                    </div>
                                </div>
                                <div class="plan-details-column">
                                    <div class="option">
                                        <div class="name">APN</div>
                                        <div class="value">fast-t-mobile.com</div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="transactionData.ratePlan.carrierId == 3" class="plan-details-columns">
                                <div class="plan-details-column">
                                    <div v-if="transactionData.ratePlan.dataLimit" class="option">
                                        <div class="name">Data limit</div>
                                        <div class="value">{{transactionData.ratePlan.dataLimit.dataLimitName}}</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">Provisioning Profile</div>
                                        <div v-if="transactionData.ratePlan.provisioningProfile" class="value">{{transactionData.ratePlan.provisioningProfile.profileName}}</div>
                                        <div v-else class="value">--</div>
                                    </div>
                                </div>
                                <div class="plan-details-column">
                                    <div class="option">
                                        <div class="name">APN</div>
                                        <div v-if="transactionData.ratePlan.provisioningProfile" class="value">{{transactionData.ratePlan.provisioningProfile.apnType}}</div>
                                        <div v-else class="value">--</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">IMEI Match Rule</div>
                                        <div v-if="transactionData.ratePlan.imeiMatch" class="value on">YES</div>
                                        <div v-else class="value">NO</div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="transactionData.ratePlan.carrierId == 4" class="plan-details-columns full-width">
                                <div class="plan-details-column ">
                                    <div v-if="transactionData.ratePlan.ratePlanCategory && transactionData.ratePlan.ratePlanCategory.planCategoryId == 14" class="option">
                                        <div class="name">Data limit</div>
                                        <div class="value">500 MB</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">Data Plan</div>
                                        <div v-if="transactionData.ratePlan.activationProfile && transactionData.ratePlan.activationProfile.dataPlanName" class="value">{{transactionData.ratePlan.activationProfile.dataPlanName}}</div>
                                        <div v-else class="value">--</div>
                                    </div>
                                    <div class="option">
                                        <div class="name">SMS Plan</div>
                                        <div v-if="transactionData.ratePlan.activationProfile && transactionData.ratePlan.activationProfile.smsPlanName" class="value">{{transactionData.ratePlan.activationProfile.smsPlanName}}</div>
                                        <div v-else class="value">--</div>
                                    </div>
                                </div>
                            </div>
                            <div class="plan-description-row">
                                <p>{{transactionData.ratePlan.planDescription}}</p>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="custom-fields-tags-box" v-if="transactionData.transactionType == 'Activation'" md="6">
                        <div class="card custom-fields-card">
                            <h6>Custom Fields</h6>
                            <div class="custom-fields">
                                <div v-for="cf in customFields" class="custom-field">
                                    <div class="name">{{cf.name}}</div>
                                    <div class="value">{{cf.value}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card tags-card">
                            <h6>Tags</h6>
                            <div class="tags">
                                <div v-for="tag in transactionData.tags" class="tag">{{tag}}</div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <div class="inner-box plan-description">
                            <b-row>
                                <b-col md="12">
                                    <h4 class="box-title">SIMs</h4>
                                </b-col>

                                <b-col md="12">
                                    <div class="siot-table-wrapper">
                                        <div class="siot-table-header">
                                            <div class="siot-table-header-left">
                                                <div class="siot-table-search">
                                                    <div class="siot-table-search-field">
                                                        <input type="text" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                                                    </div>
                                                </div>

                                                <div class="siot-table-export">
                                                    <button class="btn btn-primary mobile-sort-btn" id="simManagmentSort" @click="shwoHideSort()"><i class="fa fa-sort" aria-hidden="true"></i>Sort</button>
                                                </div>
                                            </div>

                                            <div class="siot-table-header-right">
                                                <div class="siot-table-size">
                                                    <label for="size-page">Display:</label>
                                                    <select v-on:change="sizePage()" v-model="sortSettings.size" id="size-page" class="custom-select form-control">
                                                        <option value="40">40</option>
                                                        <option value="60">60</option>
                                                        <option value="80">80</option>
                                                        <option value="100">100</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="mobileVisible == true" class="transaction-sims-mobile">
                                            <div class="list-mobile">
                                                <div v-for="(item, index) in tableData"  v-on:click="onRowClicked(item, index, null)" :data-iccid="item.transactionId" v-bind:key="index" class="item-mobile">
                                                    <div class="item-header-mobile">
                                                        <div class="icon">
                                                            <img v-if="item.carrierName == 'SimonIoT'" src="../assets/img/carrier-simon.svg"/>
                                                            <img v-else-if="item.carrierName == 'T-Mobile'" src="../assets/img/carrier-tmobile.svg"/>
                                                            <img v-else-if="item.carrierName == 'Vodafone'" src="../assets/img/carrier-vodafone.svg"/>
                                                            <img v-else src="../assets/img/carrier-simon.svg"/>
                                                        </div>
                                                        <div class="info-wrapper-mobile">
                                                            <strong class="transaction-id">{{item.sim}}</strong>
                                                            <strong class="transaction-status">{{item.transactionStatus}}</strong>
                                                        </div>
                                                    </div>
                                                    <div class="data-table-mobile">
                                                        <div class="row-mobile msisdn-mobile">
                                                            <div class="icon-mobile">
                                                                <img src="../assets/img/mobile-icons/mobile-icon14.svg" alt="">
                                                            </div>
                                                            <div class="info">
                                                                <span class="value">{{item.msisdn}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="row-mobile msisdn-mobile">
                                                            <div class="icon-mobile">
                                                                <img src="../assets/img/mobile-icons/mobile-icon7.svg" alt="">
                                                            </div>
                                                            <div class="info">
                                                                <span class="value">{{item.dataExecuted}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="siot-table-content">
                                            <div class="siot-table">
                                                <table class="table b-table table-striped table-hover b-table-selectable b-table-select-multi">
                                                    <thead :class="tableType == 2 || tableType == 3 ? 'six-columns' : ''">
                                                        <tr>
                                                            <th @click="changeSort(row.sort)" v-for="row in tableFields" role="columnheader" :aria-colindex="row.sort" :aria-label="row.label" :aria-sort="setAreaSort(row.sort)">{{row.label}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-if="tableType == 1" v-for="(log,i) in tableData" v-bind:key="log.id" @click="onRowClicked(log, i, null)">
                                                        <td>{{log.sim}}</td>
                                                        <td>{{log.msisdn}}</td>
                                                        <td>{{log.carrierName}}</td>
                                                        <td>{{log.dataExecuted}}</td>
                                                        <td>{{log.transactionStatus}}</td>
                                                    </tr>
                                                    <tr v-if="tableType == 2" v-for="(log,i) in tableData" v-bind:key="log.id" @click="onRowClicked(log, i, null)">
                                                        <td>{{log.sim}}</td>
                                                        <td>{{log.swappedToIccid}}</td>
                                                        <td>{{log.msisdn}}</td>
                                                        <td>{{log.carrierName}}</td>
                                                        <td>{{log.dataExecuted}}</td>
                                                        <td>{{log.transactionStatus}}</td>
                                                    </tr>
                                                    <tr v-if="tableType == 3" v-for="(log,i) in tableData" v-bind:key="log.id" @click="onRowClicked(log, i, null)">
                                                        <td>{{log.sim}}</td>
                                                        <td>{{log.msisdn}}</td>
                                                        <td>{{log.carrierName}}</td>
                                                        <td>{{log.dataExecuted}}</td>
                                                        <td>{{log.transactionStatus}}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="no-sims" v-if="noData == true && loadingData == false">
                                                <h2 class="text">No sim in Transaction</h2>
                                            </div>
                                        </div>
                                        <div class="siot-table-footer">
                                            <div class="siot-table-footer-center">
                                                <nav v-if="paginationCount" aria-label="Page navigation example">
                                                    <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                            <div class="loading-table" v-if="loadingData && noLoading == false">
                                <div class="loading-sims-inner">
                                    <div class="sk-wave">
                                        <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                                    </div>

                                    <div class="text">
                                        Sims are being loaded...
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <b-modal size="md" ref="selectExportFormat" id="selectExportFormat" centered hide-header hide-footer>
            <i class="fa fa-close" @click="closeExportModal"></i>
            <img src="../assets/img/file-format.svg">
            <h3>Save export file as:</h3>
            <div>
                <button class="btn btn-primary csv" v-on:click="exportCsv()">CSV</button>
                <button class="btn btn-primary xls" v-on:click="exportXlsx()">XLSX</button>
            </div>
            <button class="btn btn-light" @click="closeExportModal()">Cancel</button>
        </b-modal>
        <FTSSort v-if="mobileSort.visible" :settingsSort="sortingSettings" :directionSort="sortSettings.desc" :columnSort="sortSettings.sort" v-on:hideSort="shwoHideSort" v-on:submitSort="submitSort"></FTSSort>
    </div>
</template>

<script>
import Vue from 'vue';
import Axios from 'axios';
import globalStore from '../variables'
import Paginate from 'vuejs-paginate'
import FTSSort from "../ftsComponents/FTSSort";


export default {
    name: 'TransactionDetails',
    data() {
        return {
            sortingSettings: [
                {
                    label: 'SIM',
                    column: 1
                },
                {
                    label: 'MSISDN',
                    column: 2
                },
                {
                    label: 'Carrier',
                    column: 3
                },
                {
                    label: 'Date Executed',
                    column: 4
                },
                {
                    label: 'Transaction Status',
                    column: 5
                },
            ],
            mobileSort: {
                column: 0,
                direction: 0,
                visible: false
            },
            mobileVisible: false,
            loadingData: true,
            noLoading: false,
            transcationId: 0,
            transactionData: {
                carrierId: null,
                ratePlan: {
                    planCategory: {
                        planCategoryClass: ''
                    }
                },
                noOfSims: null,
                transactionStatus: ''
            },
            successCount: 0,
            errorCount: 0,
            queuedCount: 0,
            userFirstName: '',
            userLastName: '',
            userEmail: '',
            numberSim: 0,
            tableType: 1,
            tableFields: [
                {
                    sort: 1,
                    label: 'SIM'
                },
                {
                    sort: 2,
                    label: 'MSISDN'
                },
                {
                    sort: 3,
                    label: 'Carrier'
                },
                {
                    sort: 4,
                    label: 'Date Executed'
                },
                {
                    sort: 5,
                    label: 'Transaction Status'
                }
            ],
            tableFields2: [
                {
                    sort: 1,
                    label: 'SIM'
                },
                {
                    sort: 6,
                    label: 'Swapped'
                },
                {
                    sort: 2,
                    label: 'MSISDN'
                },
                {
                    sort: 3,
                    label: 'Carrier'
                },
                {
                    sort: 4,
                    label: 'Date Executed'
                },
                {
                    sort: 5,
                    label: 'Transaction Status'
                }
            ],
            tableFields3: [
                {
                    sort: 1,
                    label: 'SIM'
                },
                {
                    sort: 2,
                    label: 'MSISDN'
                },
                {
                    sort: 3,
                    label: 'Carrier'
                },
                {
                    sort: 4,
                    label: 'Date Executed'
                },
                {
                    sort: 5,
                    label: 'Transaction Status'
                }
            ],
            tableData: [],
            simDetails: [],
            displayPlanDetails: 0,
            planInter: 0,
            planInter2: 0,
            voice: 0,
            planSMS: 0,
            static: 0,
            hotSpot: 0,
            planPooling: 0,
            noData: false,
            refresh: false,
            interval: '',
            sortSettings: {
                page: 1,
                size: 40,
                sort: 1,
                desc: true
            },
            filter: '',
            searchString: '',
            paginationCount: 1,
            showCancelButton: false,
            customFields: {
                customField1: {
                    name: 'Custom Field 1',
                    value: '--'
                },
                customField2: {
                    name: 'Custom Field 2',
                    value: '--'
                },
                customField3: {
                    name: 'Custom Field3 ',
                    value: '--'
                },
                customField4: {
                    name: 'Custom Field4 ',
                    value: '--'
                }
            },
            hotSpotVisible: false,
            companyId: null,
            superAdmin: false
        }
    },
    components: {
        Paginate: Paginate,
        FTSSort
    },
    methods: {
        submitSort(value) {
            this.sortSettings.sort = value.column;
            this.sortSettings.desc = value.direction;
            this.getTransactionDetails(this.transcationId, true);
        },
        shwoHideSort() {
            this.mobileSort.visible = (this.mobileSort.visible == true) ? false : true;
        },
        showMobileElements() {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            if (width < 992) {
                this.mobileVisible = true;
            } else {
                this.mobileVisible = false;
            }
        },
        cancelRatePlanChange() {
            let transactionId = this.transactionData.transactionId

            Axios.patch(`${globalStore.data.restApiUrl}/sim-plan/cancel/${transactionId}`)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Cancel transaction success',
                        text: 'Transaction was canceled successfully.',
                        duration: 5000,
                    });
                }).catch(err => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Cancel transaction error',
                        text: 'Something was wrong during canceling transaction of Rate Plan Change.',
                        duration: 5000,
                    });
                    console.log(error);
                })
        },
        onRowClicked(item, index, event) {
            if (!(this.transactionData.transactionType == 'Activation' && (item.transactionStatus == 'Error' || item.transactionStatus == 'In Progress'))) {
                if (this.transactionData.transactionType == 'Rate Plan Change') {
                    this.$router.push(`/sim/management/${item.sim}`)
                } else if (item.swappedToIccid) {
                    this.$router.push(`/sim/management/${item.swappedToIccid}`)
                } else if (this.transactionData.transactionType == 'Activation' && item.transactionStatus == 'Queued') {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'SIM not activated yet',
                        text: 'This sim was not activaed yet, you can not see it\'s details.',
                        duration: 5000,
                    });
                } else if (this.transactionData.transactionType != 'Activation') {
                    this.$router.push(`/sim/management/${item.sim}`)
                } else if (this.transactionData.transactionType == 'Activation' && (item.transactionStatus == 'Completed' || item.transactionStatus == 'Success')) {
                    this.$router.push(`/sim/management/${item.sim}`)
                } else {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'SIM not activated yet',
                        text: 'This sim was not activaed yet, you can not see it\'s details.',
                        duration: 5000,
                    });
                }
            }
        },
        closeModalSim: function(ev) {
            this.numberSim = 0;
        },
        openModalSim: function(id) {
            this.numberSim = id;
        },
        getTransactionDetails(id, notPaginate) {
            this.loadingData = true;
            this.noData = false
            if (notPaginate) {
                this.sortSettings.page = 1;
                Axios.get(`${globalStore.data.restApiUrl}/transactions-new/${id}/page-count?size=${this.sortSettings.size}${this.searchString}`)
                    .then(response => {
                        this.paginationCount = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }

            Axios.get(`${globalStore.data.restApiUrl}/transactions-new/${id}?page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}${this.searchString}`)
                .then(response => {
                    if(response.data) {
                        this.transactionData = response.data;

                        this.transactionData.transactionStatus = this.transactionData.transactionStatus != null ? this.transactionData.transactionStatus : 'N/A';
                        this.transactionData.transactionType = this.transactionData.transactionType != null ? this.transactionData.transactionType : 'N/A';
                        this.transactionData.createdAt = this.transactionData.createdAt != null ? this.transactionData.createdAt : 'N/A';
                        this.transactionData.completedAt = this.transactionData.completedAt != null ? this.transactionData.completedAt : 'N/A';
                        this.transactionData.releaseAfterUtc = this.transactionData.releaseAfterUtc != null ? this.transactionData.releaseAfterUtc : 'N/A';
                        this.transactionData.carrierId = this.transactionData.carrierId != null ? this.transactionData.carrierId : 'N/A';

                        if (this.transactionData.transactionType == 'Sim Swap') {
                            this.tableFields = this.tableFields2
                            this.tableType = 2;
                        }

                        if (this.transactionData.transactionType == 'Rate Plan Change' && !this.transactionData.cancelledAtDate) {
                            this.tableFields = this.tableFields3
                            this.tableType = 3;

                            this.showCancelButton = this.transactionData.transactionStatus == "Scheduled"
                        }

                        this.queuedCount = 0

                        for (let statusRow of this.transactionData.statusesCounts) {
                            if (statusRow.status == "Success") {
                                this.successCount = statusRow.count
                            } else if (statusRow.status == "Error") {
                                this.errorCount = statusRow.count
                            } else {
                                this.queuedCount =+ statusRow.count
                            }
                        }

                        this.getUserFirstName();
                        this.getUserLastName();
                        this.getUserEmail();
                        if (this.transactionData.transactionSims.length > 0) {
                            this.prepareTableData();
                        } else {
                            this.prepareTableData();
                            this.noData = true
                            this.loadingData = false
                        }
                        this.planDetails(this.transactionData.transactionType);
                        if (this.transactionData.customFields) {
                            this.parseCustomFields();
                        }

                        if ((this.transactionData.transactionStatus == "In Progress" || this.transactionData.transactionStatus == "Queued" || this.transactionData.transactionStatus == "Submitted") && this.$router.currentRoute.name == 'TransactionDetails') {
                            this.checkInterval();
                            this.noLoading = true
                        } else {
                            this.noLoading = false
                        }


                    } else {
                        this.transactionData.transactionStatus = 'N/A';
                        this.transactionData.transactionType = 'N/A';
                        this.transactionData.createdAt = 'N/A';
                        this.transactionData.completedAt = 'N/A';
                        this.userFirstName = 'N/A';
                        this.userLastName = 'N/A';
                        this.userEmail = 'N/A';
                        this.noData = true
                        this.loadingData = false
                    }
                }).catch(error => {
                    console.log(error);
                    this.noData = true
                    this.loadingData = false

                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Getting transaction details error',
                        text: 'Something went wrong during getting transaction details. Please contact with support.',
                        duration: 3000,
                    });
                })

        },
        checkInterval() {
            this.interval = setTimeout(() => {
                this.interval = this.getTransactionDetails(this.transcationId, false);
            }, 5000)
        },
        getUserFirstName(){
            this.userFirstName = (this.transactionData.createdBy && this.transactionData.createdBy.firstName) ? this.transactionData.createdBy.firstName : '--';
        },
        getUserLastName(){
            this.userLastName = (this.transactionData.createdBy && this.transactionData.createdBy.lastName ) ? this.transactionData.createdBy.lastName : '--';
        },
        getUserEmail(){
            this.userEmail = (this.transactionData.createdBy && this.transactionData.createdBy.email) ? this.transactionData.createdBy.email : '--';
        },
        getSimInfo(sim, i){
            var tempThis = this;

            Axios.get(globalStore.data.restApiUrl + '/sims/' + sim)
                .then(response => {
                    var temp = response.data[0];
                    tempThis.parseSims(temp, i, sim);
                }).catch(error => {
                    console.log(error);
                    tempThis.loadingData = false;
                })
        },
        prepareTableData(){
            this.tableData = []
            if (this.transactionData.transactionSims.length > 0) {
                this.transactionData.transactionSims.forEach((sim, i) => {
                    if (this.transactionData.transactionType == 'Rate Plan Change') {
                        if (sim.completedOn) {
                            var executedDate = sim.completedOn
                        } else {
                            var executedDate = '-'
                        }
                        var simData = {
                            sim: sim.iccid || '-',
                            msisdn: sim.msisdn || '-',
                            carrierName: this.transactionData.carrierName || 'SimonIoT',
                            dataExecuted: executedDate,
                            transactionStatus: sim.transactionStatus || 'Queued'
                        }

                        this.tableData.push(simData)
                        this.loadingData = false;
                    } else {
                        if (sim.completedOn) {
                            var executedDate = sim.completedOn
                        } else {
                            var executedDate = '-'
                        }
                        let state;
                        if (sim.transactionStatus && sim.transactionStatus != 'New') {
                            state = sim.transactionStatus
                        } else {
                            state = 'Queued'
                        }
                        var simData = {
                            sim: sim.iccid || '-',
                            swappedToIccid: sim.swappedToIccid,
                            msisdn: sim.msisdn || '-',
                            carrierName: this.transactionData.carrierName || 'SimonIoT',
                            dataExecuted: executedDate,
                            transactionStatus: state
                        }
                        this.tableData.push(simData)
                        this.loadingData = false;
                    }
                })
            } else {
                this.noData = true;
            }
        },
        parseSims(thisSim, i, sim){
            var obj = {}, sim, msisdn, status, description, dataExecuted, transactionStatus;
            if ( thisSim !== undefined){


                msisdn = thisSim.msisdn;
                status = thisSim.status;

                if (this.transactionData.transactionSims[i].hasOwnProperty('message')) {
                    description = JSON.parse(this.transactionData.transactionSims[i].message);
                    description.error[0] ? description = description.error[0].userMessage : description = description.error.userMessage;
                } else
                    description = '-';


                dataExecuted =  this.transactionData.transactionSims[i].createdAt;
                transactionStatus =  this.transactionData.transactionSims[i].transactionStatus;

                obj = {
                    "sim" : sim,
                    "msisdn" : msisdn,
                    "status" :  status,
                    "description" : description,
                    "dataExecuted" : dataExecuted,
                    "transactionStatus" : transactionStatus
                };

                this.tableData.push(obj);

            } else {
                msisdn = '-';
                status = '-';
                if (this.transactionData.transactionSims[i].hasOwnProperty('message')) {
                    description = JSON.parse(this.transactionData.transactionSims[i].message);
                    description.error[0] ? description = description.error[0].userMessage : description = description.error.userMessage;
                } else
                    description = '-';

                dataExecuted =  this.transactionData.transactionSims[i].createdAt;
                transactionStatus =  this.transactionData.transactionSims[i].transactionStatus;
                obj = {
                    "sim" : sim,
                    "msisdn" : msisdn,
                    "status" :  status,
                    "description" : description,
                    "dataExecuted" : dataExecuted,
                    "transactionStatus" : transactionStatus
                };
                this.tableData.push(obj);
            }
        },
        planDetails(requestType){
            if (requestType === 'Activation') {
                this.displayPlanDetails = 1;

                if (this.transactionData.ratePlan && this.transactionData.ratePlan.planOptions) {
                    this.transactionData.ratePlan.planOptions.forEach(option => {
                        option.planOptionName == 'Tier 1 International Roaming' ? this.planInter = 1 : null;
                        option.planOptionName == 'Tier 2 International Roaming' ? this.planInter2 = 1 : null;
                        option.planOptionName == 'Voice' ? this.voice = 1 : null;
                        option.planOptionName == 'Data Pooling' ? this.planPooling = 1 : null;
                        option.planOptionName == 'SMS' ? this.planSMS = 1 : null;
                        option.planOptionName == 'Static IP' ? this.static = 1 : null;
                    });
                }

                if (this.transactionData.ratePlan && this.transactionData.ratePlan.hotSpotPlan) {
                    this.hotSpot = 1
                }

                if (this.transactionData.ratePlan && this.transactionData.ratePlan.planCategory) {
                    this.transactionData.ratePlan.planCategory.planCategoryClass = this.transactionData.ratePlan.planCategory.planCategoryName.toLowerCase()
                    this.transactionData.ratePlan.planCategory.planCategoryClass = this.transactionData.ratePlan.planCategory.planCategoryClass.split(' ').join('-')
                }
            }
        },
        setTimeToLocal (data) {
            let dateHistoryTime = new Date(data.getTime());

            if (dateHistoryTime.getHours() > 12) {
                let tempHour = (dateHistoryTime.getHours() + 24) % 12 || 12;
                if (dateHistoryTime.getMinutes() == 59) {
                    var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                } else {
                    var hoursHistory = tempHour + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' PM'
                }
            } else {
                if (dateHistoryTime.getHours() == 0) {
                    var hoursHistory = '12' + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                } else {
                    var hoursHistory = dateHistoryTime.getHours() + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                }
            }

            let finalDate = data.getMonth() + 1 + '/' + data.getDate() + '/' + data.getFullYear() + ' ' + hoursHistory;
            return finalDate;
        },
        searchKeyUp() {
            clearTimeout(this.timerSearch)
            this.timerSearch = setTimeout(() => {
                this.searchRow()
            }, 500)
        },
        searchKeyDown() {
            clearTimeout(this.timerSearch)
        },
        sizePage() {
            this.getTransactionDetails(this.transcationId,  true);
        },
        paginationControll(ev) {
            this.sortSettings.page = ev;
            this.getTransactionDetails(this.transcationId, false);
        },
        searchRow() {
            if (this.filter.length > 0) {
                this.searchString = '&search=' + this.filter;
            } else {
                this.searchString = ''
            }
            this.getTransactionDetails(this.transcationId, true);
        },
        changeSort(sortId) {
            if (sortId == this.sortSettings.sort) {
                this.sortSettings.desc = !this.sortSettings.desc
            }
            this.sortSettings.sort = sortId
            this.getTransactionDetails(this.transcationId, false);
        },
        setAreaSort(sortId) {
            if (sortId != this.sortSettings.sort) {
                return 'none'
            } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                return 'descending'
            } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                return 'ascending'
            }
        },
        retryTransaction() {
            Axios.post(globalStore.data.restApiUrl + '/transactions-new/retry/' + this.transcationId + '?companyId=' + this.companyId)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Transaction retry added to queue',
                        text: 'Transaction has been added to queue. Please, check its status soon.',
                        duration: 3000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Transaction retry failed',
                        text: 'Something went wrong during retrying transaction. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error)
                })
        },
        openExportModal() {
            this.$refs['selectExportFormat'].show()
        },
        closeExportModal() {
            this.$refs['selectExportFormat'].hide()
        },
        exportCsv() {
            this.$refs['selectExportFormat'].hide()

            Axios.get(globalStore.data.restApiUrl + "/transactions-new/" + this.transcationId + "/csv")
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', 'Transaction-id-' + this.transcationId + '-log.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loadingCompniesList = false;
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportXlsx() {
            this.$refs['selectExportFormat'].hide()

            Axios.get(globalStore.data.restApiUrl + "/transactions-new/" + this.transcationId + "/xlsx", {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', 'Transaction-id-' + this.transcationId + '-log.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    this.loadingCompniesList = false;
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Something went wrong during SIMs export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        parseCustomFields() {
            for (let cf of this.transactionData.customFields) {
                if (cf.customFieldId == 1) {
                    this.customFields.customField1.value = cf.customFieldName
                } else if (cf.customFieldId == 2) {
                    this.customFields.customField2.value = cf.customFieldName
                } else if (cf.customFieldId == 3) {
                    this.customFields.customField3.value = cf.customFieldName
                } else if (cf.customFieldId == 4) {
                    this.customFields.customField4.value = cf.customFieldName
                }
            }
            Axios.get(globalStore.data.restApiUrl + '/custom-fields')
                .then( response => {
                    for (let cf of response.data.fields) {
                        if (cf.index == 1) {
                            this.customFields.customField1.name = cf.label
                        } else if (cf.index == 2) {
                            this.customFields.customField2.name = cf.label
                        } else if (cf.index == 3) {
                            this.customFields.customField3.name = cf.label
                        } else if (cf.index == 4) {
                            this.customFields.customField4.name = cf.label
                        }
                    }
                })
        }
    },
    mounted() {
        this.showMobileElements();
        this.transcationId = this.$route.params.id
        this.getTransactionDetails(this.transcationId, true);

        if (this.$cookies.get('hotSpotAccess') == 'true') {
            this.hotSpotVisible = true
        } else if (this.$session.get('hotSpotAccess') == true) {
            this.hotSpotVisible = true
        } else {
            this.hotSpotVisible = false
        }

        if (this.$session.get('companyId') && this.$session.get('token')) {
            this.superAdmin = true
            this.companyId = this.$session.get('companyId')
        }
    },
    beforeDestroy() {
        clearTimeout(this.interval);
    }
}
</script>

<style lang="scss">

.transaction-details {
    .card-body {
        padding-bottom: 10px;
    }
}

.transparent-card {
    background-color: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    border: 1px solid #c9cfd4;

    .fts-table-wrapper {
        border: 0;

        .transaction-details-table {
            thead {
                tr {
                    th {
                        &:nth-child(1) {
                            width: 20%;
                        }
                        &:nth-child(2) {
                            width: 20%;
                        }
                        &:nth-child(3) {
                            width: 20%;
                        }
                        &:nth-child(4) {
                            width: 20%;
                        }
                        &:nth-child(5) {
                            width: 10%;
                        }
                    }
                }
                &.six-columns {
                    tr {
                        th {
                            &:nth-child(1) {
                                width: 20%;
                            }

                            &:nth-child(2) {
                                width: 15%;
                            }

                            &:nth-child(3) {
                                width: 15%;
                            }

                            &:nth-child(4) {
                                width: 15%;
                            }

                            &:nth-child(5) {
                                width: 15%;
                            }

                            &:nth-child(6) {
                                width: 10%;
                            }
                        }
                    }
                }
            }
        }
    }
    .card-header {
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: flex-start;
        padding: 20px !important;

        .button-wrapper {
            button {
                margin-left: 10px;
            }
        }
        .headers-box {
            h3 {
                margin: 0 0 12px;
                font-size: 18px;
                font-weight: 700;
                color: #2F353A;
            }
            h4 {
                font-size: 15px;
                font-weight: 400;
            }
        }
        .button-replay {
            button {
                i {
                    margin: 0;
                    color: #fff;
                }
            }
        }
    }
    .card-body {
        background-color: transparent;
        .details-row {
            margin: 0 20px 20px;
            .col-md-4 {
                padding: 0 20px 0 0;
                .inner-box {
                    border: 1px solid #c9cfd4;
                    padding: 20px;
                    .row {
                        margin: 0;
                        .col-md-6 {
                            padding: 0;
                        }
                    }
                }
                &:last-child {
                    padding: 0;
                }
            }
        }
        .plans-vf-tags-row {
            margin: 0;
            padding: 20px;
            background-color: #f2f2f2;
            .col-md-6 {
                max-width: calc(50% - 10px);
                padding: 0;
                margin: 0 20px 0 0;
                &:last-child {
                    margin: 0;
                }
                .plan-details {
                    height: 100%;
                    padding: 20px;
                    border: 1px solid #c8ced3;
                }
            }
        }
    }
}
.inner-box {
    position: relative;
    border-radius: 5px;
    background-color: white;

    .box-title {
        margin-bottom: 20px;
        font-size: 15px;
        font-weight: 700;
        color: #2F353A;
    }

    .label {
        display: block;
        font-size: 14px;
        color: #515B65;
    }

    .value {
        display: block;
        margin-bottom: 10px;
        min-height: 21px;

        font-size: 14px;
        color: #2F353A;
        font-weight: 700;
    }

    .row-optionplan {
        display: flex;
        .label {
            display: inline-block;
            width: 160px;
        }
    }

    &.plan-details {
        .plan-name-row {
            padding-bottom: 20px;
            border-bottom: 1px solid #C9CFD4;
            .plan-name-category-box {
                display: flex;
                align-items: center;
                flex-direction: row;
                .plan-name {
                    margin: 0 15px 0 0;
                    font-size: 16px;
                    font-weight: 700;
                }
                .plan-category {
                    display: flex;
                    align-items: center;
                    padding: 3px 12px;
                    margin: 0;
                    font-size: 16px;
                    -webkit-border-radius: 2px;
                    -moz-border-radius: 2px;
                    border-radius: 2px;
                    font-weight: 700;
                    text-transform: uppercase;
                    &.flex {
                        background-color: #abe390;
                    }
                    &.tfb-rate-plan {
                        background-color: #ffa1ec;
                    }
                    &.nb-iot {
                        background-color: #8ac8ff;
                    }
                    &.vodafone-rate-plan {
                        background-color: #ffa1a1;
                    }
                    &.kore-rate-plan {
                        background-color: #FFDDA1;
                    }
                    &.cat-m1 {
                        background-color: #ffc400;
                    }
                }
            }
        }
        .plan-details-columns {
            display: flex;
            flex-wrap: nowrap;
            &.full-width {
                .plan-details-column {
                    width: 100%;
                }
            }
            .plan-details-column {
                width: 50%;
                padding: 20px 20px 20px 0;
                .option {
                    display: flex;
                    justify-content: space-between;
                    .value {
                        &.on {
                            color: #55CD6C;
                        }
                    }
                }
            }
        }
        .plan-description-row {
            padding-top: 20px;
            border-top: 1px solid #C9CFD4;
            p {
                margin: 0;
                font-size: 12px;
            }
        }
    }
}

.custom-fields-tags-box {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .card {
        padding: 20px;
        h6 {
            font-size: 15px;
            margin: 0 0 16px;
        }
        &.custom-fields-card {
            .custom-fields {
                display: flex;
                justify-content: space-between;
                .name {}
                .value {
                    font-weight: 700;
                }
            }
        }

        &.tags-card {
            flex-grow: 1;
            margin-bottom: 0;
            .tags {
                display: flex;
                flex-wrap: wrap;

                .tag {
                    padding: 6px 20px;
                    margin: 0 10px 10px 0;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 50%;
                    -moz-border-radius: 50%;
                    border-radius: 19px;
                }
            }
        }
    }
}

.plan-description {
    margin-top: 25px;
    .box-title {
        margin: 0 0 20px 20px;
        padding: 0;
    }
    .filter-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 20px;
        border-top: 1px solid #c9cfd4;
        border-bottom: 1px solid #c9cfd4;
        .search-box {
            fieldset {
                margin-bottom: 0;
            }
        }
        .size-page-wrapper {
            display: flex;
            align-items: center;
            label {
                margin-bottom: 0;
                margin-right: 10px;
            }
        }
    }

    .transaction-details-table-wrapper {
        min-height: 300px;
    }

    .logs-table {
        position: relative;
        &.add-min-heigth {
            min-height: 200px;
        }
    }

    .transaction-details-table-paginate {
        justify-content: center;
    }
}
.table-bordered {
    border: 1px solid #c8ced3;
    thead {
        tr {
            td {
                border-bottom: 0;
            }
            &:hover {
                td {
                    a {
                        color: #fff;
                    }
                }
            }
        }
    }
    tbody {
        tr {
            &:hover {
                td {
                    a {
                        color: #fff;
                    }
                }
            }
        }
    }
}


#selectExportFormat___BV_modal_body_ {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    i {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 16px;
        cursor: pointer;
    }

    h3 {
        font-size: 15px;
        margin-top: 8px;
        margin-bottom: 20px;
    }

    .btn {
        width: 100px;
    }

    .btn-primary {
        margin: 0 10px 20px;
    }

    .btn-light {
        margin: 10px 0 0;
    }

    .csv {
        background-color: #00559F;
        border-color: #00559F;
    }
    .xls {
        background-color: #207245;
        border-color: #207245;
    }
}

.dark-theme {
    .loading-table,
    .no-data {
        background-color: rgba(0, 0, 0, 0.4);
    }
}
.loading-table,
.no-data {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    background-color: rgba(255, 255, 255, 0.7);

    .loading-sims-inner {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        flex-direction: column;
    }

    .sk-wave {
        height: 60px;
        .sk-rect {
            width: 3px;
            background-color: #39c354;
            border-radius: 4px;
        }
    }

    .text {
        text-align: center;
        font-size: 15px;
        font-weight: 700;
    }
}
table.table {
    tbody {
        tr:hover {
            cursor: pointer;
            td {
                color: #fff;
            }
        }
    }

}
.dark-theme {
    .transparent-card {
        .plans-vf-tags-row {
            background-color: #2f353a;
        }
    }

    .inner-box {
        &.plan-details {
            .plan-description-row,
            .plan-name-row {
                border-color: #1a1c1d;
            }
        }
    }

    .container-fluid {
        .transaction-details {
            .card {
                border-color: #2f353a;
                border: 1px solid #1a1c1d;
                .card-body {
                    background-color: #3a4149;
                    color: #EDEEEF;
                    .card-header {
                        background-color: #3a4149;
                        h3 {
                            color: #EDEEEF;
                        }
                    }
                    .inner-box {
                        background-color: #3a4149;
                        border-color: #1a1c1d;
                        .plan-details {
                            .plan-name-row {
                                border-color: #1a1c1d;
                            }
                        }
                        .box-title {
                            color: #EDEEEF;
                        }
                        .label {
                            color: #EDEEEF;
                        }
                        .value {
                            color: #ffffff;
                        }
                    }
                }
            }
        }
    }

    .table-bordered {
        border-color: #1a1c1d;
    }

    .table {
        color: #EDEEEF;

        thead {
            tr {
                th {
                    border-color: #1A1C1D;
                }
            }
        }

        tbody {
            tr {
                &:nth-of-type(odd) td {
                    background-color: #2F353A;
                }
                &:nth-of-type(even) td {
                    background-color: #3A4149;
                }

                td {
                    border-color: #1A1C1D;
                    .btn-secondary {
                        .fa-pencil {
                            color: #EDEEEF;
                        }
                    }
                }

                &[aria-selected="false"] {
                    .fts-checkbox-table {
                        border-color: #EDEEEF;
                    }
                }

                &[aria-selected="true"] {
                    .fts-checkbox-table {
                        border-color: #000000;
                        &::before {
                            background-color: #000000;
                        }
                    }
                    td {
                        border-color: #1A1C1D;
                        color: #23282c;
                        .btn-secondary {
                            .fa-pencil {
                                color: #23282c;
                            }
                        }
                    }
                }
                &:hover td{
                    background-color: #0088FF;
                }
            }
        }
    }
}
.dark-theme {
    .plan-description {
        .filter-row {
            border-color: #1A1C1D;
        }
    }

    .table {
        color: #EDEEEF;

        thead {
            tr {
                th {
                    border-color: #1A1C1D;
                }
            }
        }

        tbody {
            tr {
                &:nth-of-type(odd) td {
                    background-color: #2F353A;
                }
                &:nth-of-type(even) td {
                    background-color: #3A4149;
                }

                td {
                    border-color: #1A1C1D;
                    .btn-secondary {
                        .fa-pencil {
                            color: #EDEEEF;
                        }
                    }
                }

                &[aria-selected="false"] {
                    .fts-checkbox-table {
                        border-color: #EDEEEF;
                    }
                }

                &[aria-selected="true"] {
                    .fts-checkbox-table {
                        border-color: #000000;
                        &::before {
                            background-color: #000000;
                        }
                    }
                    td {
                        border-color: #1A1C1D;
                        color: #23282c;
                        .btn-secondary {
                            .fa-pencil {
                                color: #23282c;
                            }
                        }
                    }
                }
                &:hover td{
                    background-color: #0088FF;
                }
            }
        }
    }


    #selectExportFormat___BV_modal_body_ {
        background-color: #3a4149;
        color: #ffffff;
    }
}

.btn-cancel-change-plan {
    height: 33px;
    -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    background-color: #FC4D4D;
    border-color: #FC4D4D;
}

</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
